import { Component, ViewEncapsulation, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { messageService } from 'src/app/message.service';
import { PaginationService } from 'src/app/PaginationService';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { from, concatMap } from 'rxjs';

export interface DmsGroupUsersInterface {
  groupId: number;
  groupUserId: number;
  userOrRole: string;
  userOrRoleId: number;
  dmsRoles: string;
  siteId?: string; // Newly added
  updateReason: string;
  deleteReason: string;
  assignedOn: Date;
  assignedByName: string;
}

export interface DmsGroupFoldersInterface {
  groupId: number;
  folderId: number;
  cascaseToChild: string;
  updateReason: string;
  deleteReason: string;
  assignedOn: Date;
  assignedByName: string;
}

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-group-users',
  templateUrl: './group-users.component.html',
  styleUrls: ['./group-users.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GroupUsersComponent implements OnInit {

  isProcessing = true;
  searchValue: any;
  getDmsGroupUsersDetailsTableData: any = [];
  getDmsGroupFoldersDetailsTableData: any = [];
  nonorgModulesData: any;
  listOfDmsRoles: any = [];
  groupNameValue: any = "DMS";
  isUserSelectedAll: boolean = false;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  PageName: any;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};
  pagedItems: any[];
  error = '';
  makeStickyColumns: any;
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  documentTypeCall: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  columnLists: any = {};
  dataTypeList: any = [];
  array: any = [];
  visibleEditButton: boolean;
  dropDownForModules: any;
  popupTitle: any;
  oddRoleValue: any = null;
  oddUserValue: any = null;
  filteredUsersList: any[] = [];

  isEditDisabled: boolean = false;
  refreshGridData() {
    this.isProcessing = true;
    this.ngOnInit();
  }

  backToPreviousPage() {
    this.router.navigate(['dashboard/groups']);
  }

  selectedTabIndex: any;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    private readonly elem: ElementRef, public message: messageService, public paginationService: PaginationService) {
  }

  allowOnlyAllowedChars(event: KeyboardEvent): void {
    const allowedPattern = /^[A-Za-z0-9\s\-._()/\\]$/;

    const inputChar = event.key;

    if (inputChar.length === 1 && !allowedPattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.documentTypeCall.length, page, this.perPage, targetpage);
    this.pagedItems = this.documentTypeCall.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  dataGridParentCheckBoxChecked(e: any): void {
    const isChecked = e.target.checked;

    this.childCheckBoxs = isChecked;

    for (const doc of this.documentTypeCall) {
      doc.childCheckBoxs = isChecked;
    }
  }
  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.documentTypeCall[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = this.selectedTabName == 'DMS Group Folder' ? list.FOLDER_ID : list.GROUP_USER_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.documentTypeCall.some((list: any) => list.childCheckBoxs);
    this.priviousSelectedValue = idx;
  }
  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })

  }
  onClick(list: any) {
    this.message.masterDetails[0].GROUP_ID = list.GROUP_ID;
    this.router.navigate(['dashboard/groupUsers']);
  }
  private get checkboxColumns(): string[] {
    return this.dataTypeList
      .filter((type: any) => type.fieldType === 'CHECKBOX')
      .map((type: any) => type.columnName);
  }
  getcallMethod() {
    this.isProcessing = true;
    this.designationCodeValue = null;
    this.departmentCodeValue = null;
    this.statusCodeValue = null;


    this.documentTypeCall = [];
    const data = {
      gridName: this.selectedTabName == 'DMS Group Folder' ? "DMS_GROUP_FOLDER" : "DMS_GROUP_USER"
    }

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: this.selectedTabName == 'DMS Group Folder' ? "DMS_GROUP_FOLDER" : "DMS_GROUP_USER",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: this.statusCodeValue,
          codelistGroup: null,
          groupId: "" + this.message.masterDetails[0].GROUP_ID,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.documentTypeCall = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(`${size}px`);
            }

            const invisibleSet = new Set(this.columnLists.invisibleColumnarray);

            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              const columnName = this.columnLists.columnsListarray[y];

              if (invisibleSet.has(columnName)) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;
                for (const [m, targetColumn] of this.columnLists.columnsListarray.entries()) {
                  const matchingData = this.dataTypeList.find((data: any) => data.columnName === targetColumn);

                  this.columnLists.columnsListarray1.push({
                    columnsListarray: targetColumn,
                    dataType: matchingData ? matchingData.fieldType : "textbox",
                    width: this.columnLists.fieldSizeListArray
                  });
                }
                const checkboxCols = this.checkboxColumns;
                for (const doc of this.documentTypeCall) {
                  for (const colName of checkboxCols) {
                    doc[colName] = doc[colName] === "Y";
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
                this.labelcall();

              }, error: (error) => {
                this.isProcessing = false;
              }
            });
            this.message.gridList = this.documentTypeCall;
            this.collectionSize = this.documentTypeCall.length;

          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }
  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }


  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.documentTypeCall.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.documentTypeCall.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  getDmsGroupsVwDetailsData: any = {};
  gridName: any;
  ngOnInit() {
    this.isProcessing = true;
    // this.selectedTabIndex = 0;
    let currentGroupId;

    if (this.message.masterDetails && this.message.masterDetails.length > 0) {
      currentGroupId = this.message.masterDetails[0].GROUP_ID;
    }
    else {
      const storedId = sessionStorage.getItem('selectedDmsGroupId');
      if (storedId) {
        currentGroupId = Number(storedId);
        this.message.masterDetails = [{ GROUP_ID: currentGroupId }];
      }
    }

    if (!currentGroupId) {
      this.isProcessing = false;
      this.router.navigate(['dashboard/groups']);
      return;
    }

    this.groupNameValue = "DMS";
    this.labelscall();
    this.getcallMethod();

    this.appService.getDmsGroupsVwDetailsByGroupId(currentGroupId).subscribe({
      next: (response: any) => {
        this.getDmsGroupsVwDetailsData = response;
        this.dmsGroupsFieldData.groupId = response.groupId;
        this.dmsGroupsFieldData.groupName = response.groupName;
        this.dmsGroupsFieldData.groupDescription = response.groupDescription;
        this.dmsGroupsFieldData.isActive = response.isActive == 'Y';
        this.dmsGroupsFieldData.updateReason = null;
        this.gridName = 'Update DMS Groups';
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
      }
    });

    this.appService.getDmsGroupFoldersDetailsByGroupId(currentGroupId).subscribe({
      next: (response2: any) => {
        this.getDmsGroupFoldersDetailsTableData = response2;
        console.log("Group Folders - ", this.getDmsGroupFoldersDetailsTableData);
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
      }
    });

    this.nonorgModulesData = JSON.parse(sessionStorage.getItem('nonorgModulesData') || '{}');
    for (const module of this.nonorgModulesData) {
      if (module.moduleCode === "DOCS") {
        this.listOfDmsRoles = module.groupRoles ? module.groupRoles.split(",") : [];
        break;
      }
    }

    this.appService.getOneQmsUsersWithRolesVwDetails(this.groupNameValue).subscribe({
      next: (response: any) => {
        this.getDmsUsersDropdownData = response;
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
      }
    });

    this.appService.getDmsUserRolesVwDetails().subscribe({
      next: (response1: any) => {
        this.getDmsRolesDropdownData = response1;
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
      }
    });

    this.selectBoxForDmsRoles();
  }


  dmsGroupFoldersActiverFunction(isTagged: boolean): void {
    this.isActiveToggerBoxValue = isTagged;
  }

  isActiveToggerBoxValue: boolean;
  getDmsRolesDropdownData: any = [];
  getDmsUsersDropdownData: any = [];
  toggleTag: any;
  userOrRoleColumnValue: any;

  dmsGroupUsersActiverFunction(isTagged: any) {
    if (isTagged) {
      this.dmsRolesListDropdown = [];
      this.selectedDmsRole = [];
      this.isProcessing = true;
      this.appService.getOneQmsUsersWithRolesVwDetails(this.groupNameValue).subscribe({
        next: (response: any) => {
          this.getDmsUsersDropdownData = response;
          this.toggleTag = 'User';
          this.userOrRoleColumnValue = 'U';
          this.selectBoxForUserDropdown();
          this.selectBoxForDmsRoles();
          this.isProcessing = false;
          setTimeout(() => { this.isDmsRolesSelected = this.dmsRolesListDropdown.length == this.selectedDmsRole.length; })
        }, error: (error) => {
          this.isProcessing = false;
        }
      });
    }
  }

  dmsGroupRolesActiverFunction(isTagged: any) {
    if (isTagged) {
      this.isProcessing = true;
      this.selectedDmsRole = [];
      this.appService.getDmsUserRolesVwDetails().subscribe({
        next: (response1: any) => {
          this.getDmsRolesDropdownData = response1;
          this.toggleTag = 'Role';
          this.userOrRoleColumnValue = 'R';
          this.selectBoxForRoleDropdown();
          this.selectBoxForDmsRoles();
          this.isProcessing = false;
          setTimeout(() => { this.isDmsRolesSelected = this.dmsRolesListDropdown.length == this.selectedDmsRole.length; })
        }, error: (error) => {
          this.isProcessing = false;
        }
      });
    }
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };
  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
    closeDropDownOnSelection: true,
  };
  multiSelectDropdownSettingForSearchingByStatusCode: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
  };

  usersListDropdown: any = [];
  selectedUserValue: any = null;
  selectedUserOrRoleValue: any = [];
  selectedUserOrRoleId: any;

  selectedRoleValue: any = null;
  rolesListDropdown: any = [];
  selectBoxForUserDropdown(): void {
    this.usersListDropdown = [];

    if (this.toggleTag !== 'User') {
      return;
    }

    const existingUserIds = new Set(
      (this.documentTypeCall || [])
        .filter((row: any) => row.USER_OR_ROLE === 'User')
        .map((row: any) => Number(row.USER_OR_ROLE_ID))
    );

    for (const user of this.getDmsUsersDropdownData) {
      const isUserBeingEdited = this.operationFlag === 'EDIT' && Number(user.userId) === Number(this.dmsGroupUsersFieldData.userOrRoleId);
      const isAlreadyInGrid = existingUserIds.has(Number(user.userId));

      if (!isAlreadyInGrid || isUserBeingEdited) {
        this.usersListDropdown.push({
          valueExp: user.userId,
          displayExp: user.userName
        });
      }
    }

    this.filteredUsersList = [...this.usersListDropdown];
  }
  filterUsersList() {
    const search = (this.userNamesearchTxt || '').toLowerCase().trim();

    if (search.length > 0) {
      this.isUserSelectedAll = false;
    }

    if (!search) {
      this.filteredUsersList = [...this.usersListDropdown];
      return;
    }

    this.filteredUsersList = this.usersListDropdown.filter((item: any) => {
      const isSelected = this.selectedUserValue && Array.isArray(this.selectedUserValue)
        ? this.selectedUserValue.includes(item.valueExp)
        : this.selectedUserValue === item.valueExp;

      const matchesSearch = item.displayExp.toLowerCase().includes(search);
      return matchesSearch || isSelected;
    });
  }
  selectBoxForRoleDropdown(): void {
    this.rolesListDropdown = [];

    if (this.toggleTag !== 'Role') {
      return;
    }

    this.rolesListDropdown = this.getDmsRolesDropdownData.map((role: any) => ({
      valueExp: role.roleId,
      displayExp: role.roleName
    }));
  }

  dmsRolesListDropdown: any = [];
  selectedDmsRole: any = [];
  selectBoxForDmsRoles(): void {
    this.dmsRolesListDropdown = [];

    const coreRoles = new Set(['Author', 'Reviewer', 'Approver', 'Viewer', 'Publisher', 'Print User']);

    this.dmsRolesListDropdown = this.listOfDmsRoles
      .filter((role: string) => {
        if (this.toggleTag === 'User' || !this.selectedRoleValue) {
          return true;
        }
        return coreRoles.has(role);
      })
      .map((role: string) => ({
        valueExp: role,
        displayExp: role
      }));
  }
  // --- Dynamic Display Logic for Printer Site ID ---
  isPrintUserRoleSelected(): boolean {
    let isPrimaryRolePrintUser = false;
    let isDmsRolePrintUser = false;

    // 1. Check the Primary Role Dropdown (only active when 'Role' radio is selected)
    if (this.toggleTag === 'Role' && this.selectedRoleValue) {
      const selectedPrimaryRole = this.rolesListDropdown.find((r: any) => r.valueExp == this.selectedRoleValue);
      if (selectedPrimaryRole && selectedPrimaryRole.displayExp === 'Print User') {
        isPrimaryRolePrintUser = true;
      }
    }

    // 2. Check the Multi-Select DMS Roles Dropdown (active for BOTH 'User' and 'Role' selections)
    if (this.selectedDmsRole && Array.isArray(this.selectedDmsRole)) {
      if (this.selectedDmsRole.includes('Print User')) {
        isDmsRolePrintUser = true;
      }
    }

    // Show the Site ID field if 'Print User' is selected in EITHER place
    return isPrimaryRolePrintUser || isDmsRolePrintUser;
  }

  onSiteIdFocusOut() {
    const siteIdEl = document.getElementById('siteId') as HTMLInputElement;
    const msgEl = document.getElementById('siteId-required-msg') as HTMLElement;
    if (siteIdEl && msgEl) {
      if (!this.dmsGroupUsersFieldData.siteId || String(this.dmsGroupUsersFieldData.siteId).trim() === '') {
        siteIdEl.style.border = '1px solid red';
        msgEl.style.display = 'block';
      } else {
        siteIdEl.style.border = '1px solid rgba(63, 74, 63, 0.2)';
        msgEl.style.display = 'none';
      }
    }
  }

  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };
  @ViewChild('dmsGroupUsersAddAndEditPopup', { static: true }) dmsGroupUsersAddAndEditPopup: TemplateRef<any>;
  @ViewChild('dmsGroupFoldersAddAndEditPopup', { static: true }) dmsGroupFoldersAddAndEditPopup: TemplateRef<any>;
  @ViewChild('dmsGroupUsersDeletePopup', { static: true }) dmsGroupUsersDeletePopup: TemplateRef<any>;
  @ViewChild('dmsGroupFoldersDeletePopup', { static: true }) dmsGroupFoldersDeletePopup: TemplateRef<any>;
  @ViewChild('searchFoldersPopup', { static: true }) searchFoldersPopup: TemplateRef<any>;
  @ViewChild('dmsGroupActiveInactivePopup', { static: true }) dmsGroupActiveInactivePopup: TemplateRef<any>;


  visibleDmsGroupUsersAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDmsGroupFoldersAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDmsGroupUsersDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleDmsGroupFoldersDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchFoldersPopup: MatDialogRef<TemplateRef<any>>;
  visibleDmsGroupActiveInactivePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  dmsGroupUsersDeletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  dmsGroupFoldersDeletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  searchFoldersPopupConfig = {
    width: '60%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  dmsGroupActiveInactivePopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };


  /* Start DMS Group Fields */
  groupName: any;
  updateReasonValueReq: any;
  groupNameRequiredMsg: any;
  updateReasonRequiredMsg: any;
  onFieldFocusout() {
    this.groupName = document.getElementById('groupName') as HTMLInputElement;
    this.groupNameRequiredMsg = document.getElementById('groupName-required-msg') as HTMLInputElement;

    if (this.gridName == 'Update DMS Groups') {
      if (this.groupName.value) {
        this.groupName.style.border = '1px solid rgba(63, 74, 63, 0.2)';
        this.groupNameRequiredMsg.style.display = 'none';
      } else {
        this.groupName.style.border = '1px solid red';
        this.groupNameRequiredMsg.style.display = 'block';
      }
      if (this.updateReasonValueReq.value) {
        this.updateReasonValueReq.style.border = '1px solid rgba(63, 74, 63, 0.2)';
        this.updateReasonRequiredMsg.style.display = 'none';
      } else {
        this.updateReasonValueReq.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
      }
    }

    if (this.selectedTabName == "DMS Group User") {
      if (this.updateReasonValueReq.value) {
        this.updateReasonValueReq.style.border = '1px solid rgba(63, 74, 63, 0.2)';
        this.updateReasonRequiredMsg.style.display = 'none';
      } else {
        this.updateReasonValueReq.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
      }
    }

    if (this.selectedTabName == "DMS Group Folder") {
      if (this.updateReasonValueReq.value) {
        this.updateReasonValueReq.style.border = '1px solid rgba(63, 74, 63, 0.2)';
        this.updateReasonRequiredMsg.style.display = 'none';
      } else {
        this.updateReasonValueReq.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
      }
    }

  }

  isActiveValue: any;
  editDmsGroupsFunction(dmsGroupsFieldData: any) {
    this.isProcessing = true;
    this.isActiveValue = dmsGroupsFieldData.isActive == 'Y';
    if (this.dmsGroupsFieldData.groupName == null || this.dmsGroupsFieldData.groupName == undefined || this.dmsGroupsFieldData.groupName == '') {
      this.onFieldFocusout();
      this.isProcessing = false;
    } else if (this.dmsGroupsFieldData.updateReason == null || this.dmsGroupsFieldData.updateReason == undefined || this.dmsGroupsFieldData.updateReason == '') {
      this.updateReasonValueReq = document.getElementById('dmsGroupsUpdateReason') as HTMLInputElement;
      this.updateReasonRequiredMsg = document.getElementById('dmsGroupsUpdateReason-required-msg') as HTMLInputElement;
      this.updateReasonValueReq.style.border = '1px solid red';
      this.updateReasonRequiredMsg.style.display = 'block';
      this.isProcessing = false;
    } else {
      delete dmsGroupsFieldData.createdOn;
      delete dmsGroupsFieldData.updatedOn;

      let data = {
        ...this.dmsGroupsFieldData,

        groupName: dmsGroupsFieldData.groupName,
        groupDescription: dmsGroupsFieldData.groupDescription,
        updateReason: dmsGroupsFieldData.updateReason,
        isActive: dmsGroupsFieldData.isActive ? 'Y' : 'N',
      }

      this.appService.updateDmsGroups(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.ngOnInit();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  /* End DMS Group Fields */

  foldersUpdateReason: any;
  foldersUpdateReasonRequiredMsg: any;
  dmsGroupFoldersFieldValidation(): void {
    this.foldersUpdateReason = document.getElementById('foldersUpdateReason') as HTMLInputElement;
    this.foldersUpdateReasonRequiredMsg = document.getElementById('foldersUpdateReason-required-msg') as HTMLInputElement;

    if (this.operationFlag !== 'EDIT') {
      return;
    }

    if (this.dmsGroupFoldersFieldData.cascaseToChild === this.previousCascaseToChildValue) {
      this.foldersUpdateReason.style.border = '';
      this.foldersUpdateReasonRequiredMsg.style.display = 'none';
    } else {
      this.foldersUpdateReason.style.border = '1px solid red';
      this.foldersUpdateReasonRequiredMsg.style.display = 'block';
    }
  }

  dmsGroupsFieldData: any = {};
  dmsGroupUsersFieldData: any = {};
  dmsGroupFoldersFieldData: any = {};

  visibleAddButton: boolean;
  visibleDmsGroupUsersReasonForUpdateField: boolean;
  visibleDmsGroupFoldersReasonForUpdateField: boolean;
  selectedTabName: any;

  onTabChanged($event: any) {
    this.selectedTabName = $event.tab.textLabel;
    this.visibleAuditTrail = false;
    this.getcallMethod();
  }

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.isEditDisabled = false;
    this.isUserSelectedAll = false;
    this.isDmsRolesSelected = false;
    this.userNamesearchTxt = '';
    this.operationFlag = 'ADD';
    if (this.selectedTabName == "DMS Group Folder") {
      this.dmsGroupFoldersFieldData = {};
      this.popupDataTitle.title = "Create DMS Group Folder";
      this.dmsGroupFoldersFieldData.cascaseToChild = true;
      this.visibleDmsGroupFoldersReasonForUpdateField = false;
      this.selectedFolderForCreateDoc = {};
      this.visibleDmsGroupFoldersAddAndEditPopup = this.dialog.open(this.dmsGroupFoldersAddAndEditPopup, this.addAndEditPopupConfig);

    } else {
      this.popupDataTitle.title = "Create DMS Group User";
      this.toggleTag = 'User';
      this.isUserSelectedAll = false;
      this.dmsGroupUsersFieldData.userOrRoleToggle = true;
      this.selectedDmsRole = [];
      this.userOrRoleColumnValue = 'U';
      this.selectedUserValue = null;
      this.selectedRoleValue = null;
      this.dmsGroupUsersFieldData.dmsRoles = '';
      this.dmsGroupUsersFieldData.siteId = null; // Clear siteId on Add
      this.dmsGroupUsersActiverFunction(this.dmsGroupUsersFieldData.userOrRoleToggle);
      this.selectBoxForUserDropdown();
      this.selectBoxForDmsRoles();
      this.visibleDmsGroupUsersReasonForUpdateField = false;
      this.visibleDmsGroupUsersAddAndEditPopup = this.dialog.open(this.dmsGroupUsersAddAndEditPopup, this.addAndEditPopupConfig);
    }
    setTimeout(() => { this.isDmsRolesSelected = this.dmsRolesListDropdown.length == this.selectedDmsRole.length; })
  }

  previousData: any;
  previousDataGroupUserId: any;
  previousDataFolderId: any;
  positionValue: any;
  displayValue: any = [];
  getDmsGroupUsersDetailsEditData: any;
  groupIsActiveStatus: any;
  openEditPopup(editRowData: any) {
    this.operationFlag = 'EDIT';
    this.isEditDisabled = true;
    this.isProcessing = true;
    this.previousData = editRowData;
    this.groupIsActiveStatus = this.previousData.IS_ACTIVE;
    this.selectedDmsRole = [];
    this.selectedUserValue = null;
    this.selectedRoleValue = null;
    this.visibleAddButton = false;
    this.visibleEditButton = this.groupIsActiveStatus;
    if (this.selectedTabName == "DMS Group Folder") {
      this.popupDataTitle.title = "Update DMS Group Folder";
      this.previousDataFolderId = editRowData.FOLDER_ID;
      this.getSelectedFolderId = editRowData.FOLDER_ID;

      this.appService.getDmsGroupFoldersDetailsByGroupId(this.message.masterDetails[0].GROUP_ID).subscribe({
        next: (response2: any) => {
          this.getDmsGroupFoldersDetailsTableData = response2;

          const folderData = this.getDmsGroupFoldersDetailsTableData.find((f: any) => f.folderId == this.previousDataFolderId);

          if (folderData) {
            this.dmsGroupFoldersFieldData = {
              groupId: folderData.groupId,
              folderId: folderData.folderId,
              folderName: folderData.folderName,
              cascaseToChild: folderData.cascaseToChild == 'Y',
              updateReason: null
            };
          }

          this.visibleDmsGroupFoldersReasonForUpdateField = true;
          this.visibleDmsGroupFoldersAddAndEditPopup = this.dialog.open(this.dmsGroupFoldersAddAndEditPopup, this.addAndEditPopupConfig);
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
        }
      });
    }
    // FOLDER EDIT LOGIC ---
    else {
      this.popupDataTitle.title = "Update DMS Group User";
      this.previousDataGroupUserId = editRowData.GROUP_USER_ID;
      this.appService.getDmsGroupUsersDetailsByGroupUserId(editRowData.GROUP_USER_ID).subscribe({
        next: (response1: any) => {
          this.getDmsGroupUsersDetailsEditData = response1;
          this.dmsGroupUsersFieldData.groupId = this.getDmsGroupUsersDetailsEditData.groupId;
          this.dmsGroupUsersFieldData.groupUserId = this.getDmsGroupUsersDetailsEditData.groupUserId;
          this.dmsGroupUsersFieldData.userOrRoleId = this.getDmsGroupUsersDetailsEditData.userOrRoleId;
          this.dmsGroupUsersFieldData.siteId = this.getDmsGroupUsersDetailsEditData.siteId || null;

          if (this.getDmsGroupUsersDetailsEditData.dmsRoles) {

            // --- CASE A: ROLE ---
            if (this.getDmsGroupUsersDetailsEditData.userOrRole == 'Role') {
              this.dmsGroupUsersFieldData.userOrRoleToggle = true;
              this.toggleTag = 'Role';

              if (this.getDmsGroupUsersDetailsEditData.userOrRoleId) {
                this.selectBoxForRoleDropdown();

                const matchingRoleId = this.getDmsRolesDropdownData?.find((item: any) => item.roleId == this.getDmsGroupUsersDetailsEditData.userOrRoleId.toString());

                if (!matchingRoleId) {
                  this.oddRoleValue = this.getDmsGroupUsersDetailsEditData.userOrRoleId;
                  this.rolesListDropdown.push({
                    valueExp: this.getDmsGroupUsersDetailsEditData.userOrRoleId.toString(),
                    displayExp: this.getDmsGroupUsersDetailsEditData.userOrRoleId.toString()
                  })
                }
                this.selectedRoleValue = this.getDmsGroupUsersDetailsEditData.userOrRoleId.toString();
              }
              this.dmsGroupRolesActiverFunction(this.dmsGroupUsersFieldData.userOrRoleToggle);
            }

            // --- CASE B: USER ---
            else {
              this.dmsGroupUsersFieldData.userOrRoleToggle = true;
              this.toggleTag = 'User';

              if (this.getDmsGroupUsersDetailsEditData.userOrRoleId) {
                this.selectBoxForUserDropdown();

                const matchingUserId = this.getDmsUsersDropdownData?.find((item: any) => item.userId == this.getDmsGroupUsersDetailsEditData.userOrRoleId);

                if (!matchingUserId) {
                  this.oddUserValue = this.getDmsGroupUsersDetailsEditData.userOrRoleId;
                  this.usersListDropdown.push({
                    valueExp: this.getDmsGroupUsersDetailsEditData.userOrRoleId,
                    displayExp: this.getDmsGroupUsersDetailsEditData.userOrRoleName || this.getDmsGroupUsersDetailsEditData.userOrRoleId // Fallback
                  })
                }
                // Assign single value (not array) because [multiple] is false in EDIT mode
                this.selectedUserValue = this.getDmsGroupUsersDetailsEditData.userOrRoleId;
              }
              this.dmsGroupUsersActiverFunction(this.dmsGroupUsersFieldData.userOrRoleToggle);
            }

            // Handle DMS Roles
            this.selectedDmsRole = this.getDmsGroupUsersDetailsEditData.dmsRoles ? this.getDmsGroupUsersDetailsEditData.dmsRoles.split(",") : [];
            setTimeout(() => { this.isDmsRolesSelected = this.dmsRolesListDropdown.length == this.selectedDmsRole.length; })
          } else {
            this.selectedDmsRole = [];
          }

          this.visibleDmsGroupUsersReasonForUpdateField = true;
          this.dmsGroupUsersFieldData.updateReason = null;
          this.visibleDmsGroupUsersAddAndEditPopup = this.dialog.open(this.dmsGroupUsersAddAndEditPopup, this.addAndEditPopupConfig);
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
        }
      })
    }
  }

  groupUsersUserValueRequiredMsg: any;
  groupUsersRoleValueRequiredMsg: any;
  getSelectedUsersLabel(): string {
    if (!this.selectedUserValue || (Array.isArray(this.selectedUserValue) && this.selectedUserValue.length === 0)) {
      return 'Select';
    }
    if (!Array.isArray(this.selectedUserValue)) {
      const single = this.usersListDropdown.find((u: any) => u.valueExp == this.selectedUserValue);
      return single ? single.displayExp : '';
    }
    const selectedNames = this.usersListDropdown
      .filter((u: any) => this.selectedUserValue.some((sv: any) => sv == u.valueExp))
      .map((u: any) => u.displayExp);
    if (selectedNames.length === 0) return 'Select';
    if (selectedNames.length > 1) {
      return `${selectedNames[0]} (+${selectedNames.length - 1} more)`;
    } else {
      return selectedNames[0];
    }
  }
  addAndEditFunctionForDmsGroupUsers(dmsGroupUsersFieldData: any) {
    this.isProcessing = true;

    // --- Validation logic for Printer Site ID Field ---
    if (this.isPrintUserRoleSelected()) {
      if (!this.dmsGroupUsersFieldData.siteId || String(this.dmsGroupUsersFieldData.siteId).trim() === '') {
        this.onSiteIdFocusOut(); // Highlights border
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: "Printer Site ID is required for Print User role.",
            type: 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'Error'
        });
        sb.onAction().subscribe(() => sb.dismiss());
        this.isProcessing = false;
        return;
      }
    } else {
      // Clean up lingering values if Role changed from Print User -> another role before Save.
      this.dmsGroupUsersFieldData.siteId = null;
    }

    if (this.toggleTag == 'User' && (!this.selectedUserValue || this.selectedUserValue.length === 0)) {
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: "Please select at least one user",
          type: 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'Error'
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });

      this.isProcessing = false;
      return;
    }
    if (!this.selectedDmsRole || this.selectedDmsRole.length === 0) {
      // Optional: Focus the select or scroll to it
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: "Please select at least one DMS Role",
          type: 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'Error'
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });

      this.isProcessing = false;
      return;
    }
    // --- 2. SEQUENTIAL LOGIC FOR USERS (ADD OPERATION) ---
    if (this.toggleTag == 'User' && this.operationFlag == 'ADD') {

      // Slice to first 50 just to be safe
      let usersToProcess = this.selectedUserValue.slice(0, 50);

      const baseData = {

        groupId: this.message.masterDetails[0].GROUP_ID,
        userOrRole: this.userOrRoleColumnValue,
        siteId: this.dmsGroupUsersFieldData.siteId, // SiteId payload mapping
        dmsRoles: this.selectedDmsRole.length > 0 ? this.selectedDmsRole.join(',') : undefined
      };

      // 'from' to turn array into a stream, and 'concatMap' to process one by one
      from(usersToProcess).pipe(
        concatMap((singleUserId: any) => {
          const payload = {
            ...baseData,
            userOrRoleId: singleUserId
          };
          //Observable to complete before starting the next one
          return this.appService.createDmsGruoupUsers(payload);
        })
      ).subscribe({
        next: (response: any) => {
          // You can handle individual success here if needed (optional)
          console.log('Processed user:', response);
        },
        complete: () => {
          // This runs only after ALL users in the list are processed successfully
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: "User/Role has been created successfully.",
              type: 'Success',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'Success'
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

          this.visibleDmsGroupUsersAddAndEditPopup.close();
          this.isProcessing = false;
          this.getcallMethod();
        },
        error: (error: any) => {
          this.isProcessing = false;
          console.error('Sequence failed', error);
        }
      });

      return;
    }
    if (this.operationFlag == 'ADD') {

      dmsGroupUsersFieldData.groupId = this.message.masterDetails[0].GROUP_ID;

      if (this.selectedRoleValue) {
        dmsGroupUsersFieldData.userOrRoleId = this.selectedRoleValue;
        dmsGroupUsersFieldData.userOrRole = this.userOrRoleColumnValue;
      } else {
        dmsGroupUsersFieldData.userOrRoleId = null;
        dmsGroupUsersFieldData.userOrRole = '';
      }

      // DMS Roles
      if (this.selectedDmsRole.length) {
        dmsGroupUsersFieldData.dmsRoles = this.selectedDmsRole.join(',');
      } else {
        dmsGroupUsersFieldData.dmsRoles = undefined;
      }

      this.appService.createDmsGruoupUsers(this.dmsGroupUsersFieldData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.ngOnInit();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.visibleDmsGroupUsersAddAndEditPopup.close();
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });

    }
    // --- Updates ---
    else {
      if (this.dmsGroupUsersFieldData.updateReason == null || this.dmsGroupUsersFieldData.updateReason == undefined || this.dmsGroupUsersFieldData.updateReason == '') {
        this.updateReasonValueReq = document.getElementById('groupUsersUpdateReason') as HTMLInputElement;
        this.updateReasonRequiredMsg = document.getElementById('groupUsersUpdateReason-required-msg') as HTMLInputElement;
        this.updateReasonValueReq.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
        this.isProcessing = false;
      } else {
        delete dmsGroupUsersFieldData.createdOn;
        delete dmsGroupUsersFieldData.updatedOn;


        dmsGroupUsersFieldData.groupId = this.message.masterDetails[0].GROUP_ID;

        // Edit Payload construction
        // For Edit, we take the single value if it's an array (standard edit behavior)
        if (this.toggleTag == 'User' && Array.isArray(this.selectedUserValue)) {
          dmsGroupUsersFieldData.userOrRoleId = this.selectedUserValue[0];
        } else if (this.toggleTag == 'User') {
          dmsGroupUsersFieldData.userOrRoleId = this.selectedUserValue;
        } else {
          dmsGroupUsersFieldData.userOrRoleId = this.selectedRoleValue;
        }

        dmsGroupUsersFieldData.userOrRole = this.userOrRoleColumnValue;

        dmsGroupUsersFieldData.dmsRoles = '';
        if (this.selectedDmsRole.length) {
          dmsGroupUsersFieldData.dmsRoles = this.selectedDmsRole.join(',');
        } else {
          dmsGroupUsersFieldData.dmsRoles = undefined;
        }

        this.appService.updateDmsGroupUsers(this.dmsGroupUsersFieldData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.ngOnInit();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.visibleDmsGroupUsersAddAndEditPopup.close();
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunctionForDmsGroupUsers() {
    this.visibleDmsGroupUsersAddAndEditPopup.close();
  }

  previousCascaseToChildValue: any;
  addAndEditFunctionForDmsGroupFolders(dmsGroupFoldersFieldData: any) {
    this.isProcessing = true;
    let data = {
      groupId: this.message.masterDetails[0].GROUP_ID,
      folderId: this.dmsGroupFoldersFieldData.folderId,
      cascaseToChild: dmsGroupFoldersFieldData.cascaseToChild ? 'Y' : 'N',
    }

    if (this.operationFlag == 'ADD') {
      this.appService.createDmsGruoupFolders(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.ngOnInit();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.visibleDmsGroupFoldersAddAndEditPopup.close();
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.previousCascaseToChildValue = this.previousData.cascaseToChild == 'Y';
      if (this.dmsGroupFoldersFieldData.updateReason == null || this.dmsGroupFoldersFieldData.updateReason == undefined || this.dmsGroupFoldersFieldData.updateReason == '') {
        this.updateReasonValueReq = document.getElementById('foldersUpdateReason') as HTMLInputElement;
        this.updateReasonRequiredMsg = document.getElementById('foldersUpdateReason-required-msg') as HTMLInputElement;
        this.updateReasonValueReq.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
        this.isProcessing = false;
      } else {
        delete dmsGroupFoldersFieldData.createdOn;
        delete dmsGroupFoldersFieldData.updatedOn;


        let modifiedData = {
          ...data,
          updateReason: dmsGroupFoldersFieldData.updateReason
        }

        this.appService.updateDmsGroupFolders(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.getcallMethod();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.visibleDmsGroupFoldersAddAndEditPopup.close();
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunctionForDmsGroupFolders() {
    this.visibleDmsGroupFoldersAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteDmsGroupUsersId: any;
  deleteDmsGroupFoldersId: any;
  deleteDmsGroupFoldersGroupId: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    if (this.selectedTabName == "DMS Group Folder") {
      this.popupDataTitle.title = "Delete Group Folder";
      this.deleteDmsGroupFoldersId = deleteRowData.FOLDER_ID;
      this.deleteDmsGroupFoldersGroupId = deleteRowData.GROUP_ID;
      if (this.dmsGroupFoldersFieldData.deleteReason != undefined) {
        this.dmsGroupFoldersFieldData.deleteReason = '';
      }
      this.visibleDmsGroupFoldersDeletePopup = this.dialog.open(this.dmsGroupFoldersDeletePopup, this.dmsGroupFoldersDeletePopupConfig);
    } else {
      this.popupDataTitle.title = "Delete Group User";
      this.deleteDmsGroupUsersId = deleteRowData.GROUP_USER_ID;
      if (this.dmsGroupUsersFieldData.deleteReason != undefined) {
        this.dmsGroupUsersFieldData.deleteReason = '';
      }
      this.visibleDmsGroupUsersDeletePopup = this.dialog.open(this.dmsGroupUsersDeletePopup, this.dmsGroupUsersDeletePopupConfig);
    }

  }

  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
      return
    }
    if (this.selectedTabName == "DMS Group Folder") {
      let dataDmsGroupFolders = {
        groupId: this.deleteDmsGroupFoldersGroupId,
        folderId: this.deleteDmsGroupFoldersId,
        deleteReason: this.dmsGroupFoldersFieldData.deleteReason,
      }
      this.appService.deleteDmsGroupFolders(dataDmsGroupFolders).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.ngOnInit();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.visibleDmsGroupFoldersDeletePopup.close();
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      let dataDmsGroupUsers = {

        groupUserId: this.deleteDmsGroupUsersId,
        groupId: this.message.masterDetails[0].GROUP_ID,
        deleteReason: this.dmsGroupUsersFieldData.deleteReason,
      }
      this.appService.deleteDmsGroupUsers(dataDmsGroupUsers).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.ngOnInit();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.visibleDmsGroupUsersDeletePopup.close();
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    if (this.selectedTabName == "DMS Group Folder") {
      this.visibleDmsGroupFoldersDeletePopup.close();
    } else {
      this.visibleDmsGroupUsersDeletePopup.close();
    }
  }

  focusEmpty() {
    console.log();
  }
  getDmsFoldersVwDetails: any = [];
  searchManagerFunction() {
    this.popupDataTitle.title = "Search Folders";
    this.visibleSearchFoldersPopup = this.dialog.open(this.searchFoldersPopup, this.searchFoldersPopupConfig);
  }

  model = {
    documentData: {},
  };
  selectedFolderForCreateDoc: any = {};
  changeInFolderStructureChild(data: any) {
    this.model = data;
    this.selectedFolderForCreateDoc = this.model.documentData;

  }

  searchFoldersParentCheckBox: boolean = false;
  searchFoldersChildCheckBoxs: boolean = false;
  searchManagerChildCheckBoxsMenu: boolean = false;

  searchFoldersDataGridParentCheckBoxChecked(e: any): void {
    const isChecked = e.target.checked;

    for (const folder of this.getDmsFoldersVwDetails) {
      folder.searchFoldersChildCheckBoxs = isChecked;
    }
  }

  getSelectedFolderId: any;
  getSelectedFolderName: string;
  searchFoldersPreviousValue: any
  searchFoldersChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {

    if (e.target.checked) {
      if (this.searchFoldersPreviousValue != undefined) {
        this.getDmsFoldersVwDetails[this.searchFoldersPreviousValue].searchFoldersChildCheckBoxs = false;
      }
      listOfUsersVwDetails.searchFoldersChildCheckBoxs = true;
      this.getSelectedFolderId = listOfUsersVwDetails.folderId
      this.getSelectedFolderName = listOfUsersVwDetails.folderName;
    } else {
      listOfUsersVwDetails.searchFoldersChildCheckBoxs = false;
      this.getSelectedFolderId = null;
      this.getSelectedFolderName = '';
    }
    this.searchFoldersPreviousValue = idx;
  }

  addFolderFunction() {
    this.dmsGroupFoldersFieldData.folderId = this.selectedFolderForCreateDoc.folderId;
    this.dmsGroupFoldersFieldData.folderName = this.selectedFolderForCreateDoc.folderName;
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Create DMS Group Folder" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Update DMS Group Folder" : "";
    }
    this.visibleSearchFoldersPopup.close();
  }

  cancelSeachFoldersFunction() {
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Create DMS Group Folder" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Update DMS Group Folder" : "";
    }
    this.visibleSearchFoldersPopup.close();
  }

  activeInactiveLabel: string;
  activeInactiveButtonLabel: string;
  errorMsgContent: string;
  activeInactiveGroupUserId: number;
  activeInactiveGroupId: number;
  activeInactiveFolderId: number;
  groupActionFlag: boolean;
  isFromGroupUser: boolean;
  isFromGroupFolder: boolean;
  openActiveAndInActivePopup(dmsGroupUsersActiveInactiveRowData: any) {
    this.isFromGroupUser = true;
    this.isFromGroupFolder = false;
    if (dmsGroupUsersActiveInactiveRowData.IS_ACTIVE) {
      this.popupTitle = "Group User Inactivation";
      this.activeInactiveLabel = "Reason for Inactivation";
      this.activeInactiveButtonLabel = "Inactivate";
      this.errorMsgContent = "Inactivation";
      this.groupActionFlag = false;
    } else {
      this.popupTitle = "Group User Activation";
      this.activeInactiveLabel = "Reason for Activation";
      this.activeInactiveButtonLabel = "Activate";
      this.errorMsgContent = "Activation";
      this.groupActionFlag = true;
    }
    this.activeInactiveGroupUserId = dmsGroupUsersActiveInactiveRowData.GROUP_USER_ID;
    this.dmsGroupFoldersFieldData.groupActiveInactiveReason = "";
    this.visibleDmsGroupActiveInactivePopup = this.dialog.open(this.dmsGroupActiveInactivePopup, this.dmsGroupActiveInactivePopupConfig);
  }

  openActiveAndInActivePopupForFolder(dmsGroupFolderActiveInactiveRowData: any) {
    this.isFromGroupFolder = true;
    this.isFromGroupUser = false;
    if (dmsGroupFolderActiveInactiveRowData.IS_ACTIVE) {
      this.popupTitle = "Group Folder Inactivation";
      this.activeInactiveLabel = "Reason for Inactivation";
      this.activeInactiveButtonLabel = "Inactivate";
      this.errorMsgContent = "Inactivation";
      this.groupActionFlag = false;
    } else {
      this.popupTitle = "Group Folder Activation";
      this.activeInactiveLabel = "Reason for Activation";
      this.activeInactiveButtonLabel = "Activate";
      this.errorMsgContent = "Activation";
      this.groupActionFlag = true;
    }
    this.activeInactiveGroupId = dmsGroupFolderActiveInactiveRowData.GROUP_ID;
    this.activeInactiveFolderId = dmsGroupFolderActiveInactiveRowData.FOLDER_ID;
    this.dmsGroupFoldersFieldData.groupActiveInactiveReason = "";
    this.visibleDmsGroupActiveInactivePopup = this.dialog.open(this.dmsGroupActiveInactivePopup, this.dmsGroupActiveInactivePopupConfig);
  }

  cancelDmsGroupActiveInActiveFunction() {
    this.visibleDmsGroupActiveInactivePopup.close();
  }

  groupActiveInactiveReasonValue: any;
  groupActiveInactiveReasonRequiredMsg: any;
  tmsGroupActiveInactiveValidation() {
    this.groupActiveInactiveReasonValue = document.getElementById('groupActiveInactiveReason') as HTMLInputElement;
    this.groupActiveInactiveReasonRequiredMsg = document.getElementById('groupActiveInactiveReason-required-msg') as HTMLInputElement;
    if (this.dmsGroupFoldersFieldData.groupActiveInactiveReason == "") {
      this.groupActiveInactiveReasonValue.style.border = '1px solid red';
      this.groupActiveInactiveReasonRequiredMsg.style.display = 'block';
    } else {
      this.groupActiveInactiveReasonValue.style.border = 'none';
      this.groupActiveInactiveReasonRequiredMsg.style.display = 'none';
    }
  }

  dmsGroupActiveInActiveFunction(dmsGroupFoldersFieldData: any) {
    this.isProcessing = true;
    if (this.dmsGroupFoldersFieldData.groupActiveInactiveReason == "") {
      this.tmsGroupActiveInactiveValidation();
      this.isProcessing = false;
    } else {
      const isActiveValue = this.groupActionFlag ? 'ACTIVATE' : 'INACTIVATE';
      let dmsGroupUserActiveInactiveData = {

        groupUserId: this.activeInactiveGroupUserId,
        isActive: isActiveValue,
        inActiveReason: this.dmsGroupFoldersFieldData.groupActiveInactiveReason,
      };
      this.appService.dmsGroupActiveInactive(dmsGroupUserActiveInactiveData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleDmsGroupActiveInactivePopup.close();
            this.getcallMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          throw error;
        }
      });
    }
  }

  dmsGroupFolderActiveInActiveFunction(dmsGroupFoldersFieldData: any) {
    this.isProcessing = true;
    if (this.dmsGroupFoldersFieldData.groupActiveInactiveReason == "") {
      this.tmsGroupActiveInactiveValidation();
      this.isProcessing = false;
    } else {
      const isActiveValue = this.groupActionFlag ? 'ACTIVATE' : 'INACTIVATE';
      let dmsGroupFolderActiveInactiveData = {

        groupId: this.activeInactiveGroupId,
        folderId: this.activeInactiveFolderId,
        isActive: isActiveValue,
        inActiveReason: this.dmsGroupFoldersFieldData.groupActiveInactiveReason,
      };
      this.appService.dmsGroupFolderActiveInactive(dmsGroupFolderActiveInactiveData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleDmsGroupActiveInactivePopup.close();
            this.getcallMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          throw error;
        }
      });
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.documentTypeCall.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }


  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, group: any) {
    let refNoMapping: Record<number, number> = { 0: group.GROUP_USER_ID, 1: group.FOLDER_ID, };
    this.auditTrail.refNo = viewType == 'overAll' ? null : refNoMapping[this.selectedTabIndex === undefined ? 0 : this.selectedTabIndex];
    this.auditTrail.groupId = this.message.masterDetails[0].GROUP_ID;
    this.auditTrail.gridName = this.selectedTabIndex == 1 ? "DMS_GROUP_FOLDER" : "DMS_GROUP_USER"
    this.auditTrail.report_And_Popup_Name = this.selectedTabIndex == 1 ? 'DMS Group Folder Audit Trail' : 'DMS Group User Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(group);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.selectedTabIndex == 1 ? 'Documents Group Folder Report' : 'Documents Group User Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  dmsRolesearchTxt: string = '';


  @ViewChild('dmsRoles') dmsRoles: MatSelect;

  isDmsRolesSelected = false;

  toggleAllSelection(tag: any) {
    if (tag == 'users') {
      if (this.isUserSelectedAll) {
        let allUserIds = this.usersListDropdown.map((item: any) => item.valueExp);

        if (allUserIds.length > 50) {
          this.selectedUserValue = allUserIds.slice(0, 50);
          alert("User selection is more, only 50 is selected.");
        } else {
          this.selectedUserValue = allUserIds;
        }
      } else {
        this.selectedUserValue = [];
      }
      this.filterUsersList();
    } else if (tag == 'dmsRoles') {
      if (this.isDmsRolesSelected) {
        this.selectedDmsRole = this.dmsRolesListDropdown.map((item: any) => item.valueExp);
      } else {
        this.selectedDmsRole = [];
      }
    }
  }
  onDmsRoleSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.isDmsRolesSelected = this.dmsRolesListDropdown.length == this.selectedDmsRole.length; })
    }
  }

  rolesearchTxt: any;

  onRoleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedRoleValue = item.valueExp;
        if (this.groupUsersRoleValueRequiredMsg != undefined) {
          this.groupUsersRoleValueRequiredMsg.style.display = 'none';
        }
      } else {

        this.selectedRoleValue = undefined;
        if (this.groupUsersRoleValueRequiredMsg != undefined) {
          this.groupUsersRoleValueRequiredMsg.style.display = 'red';
        }
      }
    }
    setTimeout(() => { this.selectBoxForDmsRoles(); })
  }

  userNamesearchTxt: any;
  onUserSelect(event: any, item: any) {
    if (event.isUserInput) {
      // Check if we have any values selected
      const hasSelection = this.selectedUserValue && this.selectedUserValue.length > 0;

      // Handle Validation Message visibility
      if (this.groupUsersUserValueRequiredMsg) {
        this.groupUsersUserValueRequiredMsg.style.display = hasSelection ? 'none' : 'block';
        // Add red border to the select if needed
      }

      // Handle "Select All" checkbox state
      setTimeout(() => {
        this.isUserSelectedAll = this.selectedUserValue &&
          this.usersListDropdown.length > 0 &&
          this.selectedUserValue.length === this.usersListDropdown.length;
      });
    }
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  labels: any = [];
  dynamicLabels: any = null;
  labelscall() {
    this.isProcessing = true;
    let data = {

      tableName: 'DMS_GROUPS_VW',
      moduleName: null,
      gridName: 'DMS_GROUP',
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.labels = data;
        this.dynamicLabels = this.labels.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }


}
